import request from 'utils/request';

/**
 * Adds one or more packages to a user’s Favorites list
 * @param  {Number} item_id    	Id of item requested
 * @return {Promise}
 */
export function addFavorite({ itemID }) { // eslint-disable-line camelcase
	return request('/api/v1/favorites', {
		authenticate: true,
		method: 'POST',
		body: { item_id: itemID }
	});
}

/**
 * Removes a single package from a user’s Favorites list
 * @param  {Number} item_id    	Id of item requested
 * @return {Promise}
 */
export function removeFavorite({ itemID }) {
	return request(`/api/v1/favorites/${itemID}`, {
		authenticate: true,
		method: 'DELETE'
	});
}

export default {
	addFavorite,
	removeFavorite
};
